import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { IconButton } from '@cbrebuild/blocks';
import PercentDollarInput from '../../../nucleus/inputs/PercentDollarInput';
import { updateVoucher } from '../../../redux/actions/voucher/voucher-actions';
import useFormState, { EVENT_VALUE_TYPES } from '../../../hooks/useFormState';
import { deleteRebate, updateRebate } from '../../../redux/actions/rebates-actions';
import FormGroup from '../../../nucleus/form-group/form-group';
import { selectTotalCommissionsForRebates } from '../../../redux/selectors/voucher-selectors';

const selectRebateById = (state, id) => (
  state.rebates.rebates.find(rebate => rebate.id === id)
);

const typeOverrides = {
  voucher_gross_commission_percent: EVENT_VALUE_TYPES.FLOAT,
  gross_commission: EVENT_VALUE_TYPES.FLOAT,
};

const RebateItem = ({
  id,
  dealId,
  voucherId,
  showValidation,
  rebate_is_percent,
}) => {
  const rebate = useSelector(state => selectRebateById(state, id)) || {};
  const baseTotal = useSelector(selectTotalCommissionsForRebates);
  const dispatch = useDispatch();
  const {
    rebate_client_name, gross_commission, voucher_gross_commission_percent,
    onStateChange, onStateChanged,
  } = useFormState({
    rebate_client_name: rebate.rebate_client_name,
    gross_commission: rebate.gross_commission,
    voucher_gross_commission_percent: rebate.voucher_gross_commission_percent,
  }, changes => dispatch(updateRebate(id, changes)), typeOverrides, { rowType: 'rebate', rowId: id });

  const onUpdateVoucher = ({ target: { name, value } }) => {
    dispatch(updateVoucher(voucherId, { [name]: value }));
  };

  const onDelete = () => {
    dispatch(deleteRebate(id));
  };

  const invalidGrossCommission = (showValidation || gross_commission.dirty) && !gross_commission.value;

  return (
    <div className="form-row-with-labels-and-hints">
      <FormGroup label="PRV - Client Name" size="large" className="due-upon-field" hasError={false}>
        <input
          type="text"
          name="rebate_client_name"
          value={rebate_client_name.value || ''}
          onChange={onStateChange}
          onBlur={onStateChanged}
        />
      </FormGroup>
      <PercentDollarInput
        isRequired={invalidGrossCommission}
        label={`${invalidGrossCommission ? '' : '* '}amount`}
        name={{
          percentage: 'voucher_gross_commission_percent',
          value: 'gross_commission',
          select: 'rebate_is_percent',
        }}
        className={invalidGrossCommission ? 'errorInput' : ''}
        onTypeChange={onUpdateVoucher}
        onChange={onStateChange}
        onBlur={onStateChanged}
        baseTotal={baseTotal}
        percentage={voucher_gross_commission_percent.value}
        value={gross_commission.value}
        isPercent={rebate_is_percent}
      />
      <IconButton className="blxs-button-icon-small" iconName="close-circle" onClick={onDelete} variant="basic" />
    </div>
  );
};

RebateItem.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  showValidation: PropTypes.bool.isRequired,
  dealId: PropTypes.number.isRequired,
  voucherId: PropTypes.number.isRequired,
  rebate_is_percent: PropTypes.bool.isRequired,
};

export default RebateItem;
